import { useRef, useState } from 'react';
import cx from 'clsx';
import { useOutsideClick } from '@kcd/design-system';

import { ExclamationIcon } from '~/assets/icons';

type Props = {
  description: string;
  className?: string;
};

export function MembershipDiscountTooltip({ description, className }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useOutsideClick({
    ref,
    onClick: () => {
      if (visible) {
        setVisible(false);
      }
    },
  });

  return (
    <div className={cx(['relative w-16', className])} ref={ref}>
      {visible && (
        <div className="absolute top-[30px] z-10 rounded-lg bg-gray-1200 px-12 py-8 text-center typo-caption100-regular after:absolute after:bottom-full after:left-1/2 after:border-8 after:border-x-transparent after:border-b-gray-1200 after:border-t-transparent after:content-['']">
          <p className="whitespace-nowrap text-gray-000">{description}</p>
        </div>
      )}
      <ExclamationIcon
        className="text-gray-500"
        onClick={() => setVisible(true)}
      />
    </div>
  );
}
